module.exports = __webpack_public_path__ + "static/media/图片5.81f90806.png";